<template>
  <div class="cardbox commentarea">
    <div class="centerblockimg" v-if="!comments || comments.length === 0">
      <svgicon v-if="showEmpty" name="NoComments" width="100px" height="190px" :original="true"/>
      <div>No comments yet!</div>
    </div>
    <div class="commentheight" v-else>
      <div class="commentarea-list" v-for="(comment,index) in comments" :key="index">
        <div class="commentprofile">
          <span class="commentprofile-psign" v-if="getCommentParty(comment.party)">
            {{getCommentParty(comment.party)}}</span>
            <span class="commentprofile-dt">
              <strong> {{getTitleCase(comment.user_name)}} </strong>
            </span>
          <span class="commentprofile-dt">{{getCommentDate(comment.created_at)}}</span>
        </div>
        <p v-html="getHighlightedMessage(comment.message)"></p>
      </div>
    </div>
    <div class="commentarea-inputfield">
      <vue-tribute :options="options">
        <div id="comments-input"
             class="content-editable"
             contenteditable="true"
             placeholder="Add your comment"
             @keydown="preventDefault($event)"
             @keyup="preventDefault($event)"
             @input="updateHTML"/>
      </vue-tribute>
    </div>
    <div class="comments-action">
      <div class="actionbtn">
        <span class="actionbtn-sectext" @click="clearMessage()">Cancel</span>
        <span class="actionbtn-primarytext ml-10" @click="add()">Add</span>
      </div>
    </div>
  </div>
</template>
<script>
  import {invert} from 'lodash';
  import {commentParty} from 'pando-constants';
  import {formatCommentDate} from '@/lib/Date';
  import VueTribute from "vue-tribute";
  import tags from '@common/constants/comment-tags';
  import VueSanitize from "vue-sanitize";
  import Vue from 'vue';

  let defaultOptions;
  defaultOptions = {
    allowedTags: ['div'],
    allowedAttributes: {
      'div': ['class', 'contenteditable']
    }
  };
  Vue.use(VueSanitize,defaultOptions );

  export default {
    props: {
      comments: {
        default: [],
      },
      showEmpty: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      VueTribute,
    },
    data() {
      return {
        message: '',
        commentsPartyConst: {},
        openTag: '<div class="comment-tag" contenteditable="false">',
        closeTag: '</div>',
        options: {}
      };
    },
    created() {
      let valueSet = this.getValueSet();
      this.commentsPartyConst = invert(commentParty);
      this.options = {
        trigger: "#",
        selectTemplate: function (item) {
          return '<div class="comment-tag" contenteditable="false">' + '#' + item.original.value + '</div>';
        },
        values: valueSet,
      }
    },
    methods: {
      getValueSet() {
        let valueSet = [];
        for (var index = 0; index < tags.length; index++) {
          valueSet.push({key: tags[index], value: tags[index]});
        }
        return valueSet;
      },
      updateHTML(e) {
        this.message = e.target.innerHTML;
      },
      getCommentParty(party) {
        return this.commentsPartyConst[party] && this.commentsPartyConst[party][0];
      },
      getCommentDate(date) {
        return formatCommentDate(date);
      },
      getTitleCase(userName) {
        if (!userName || userName.includes('@')){
          return userName;
        }
        return userName.toLowerCase().split(' ').map(function(word) {
          return word.replace(word[0], word[0].toUpperCase());
        }).join(' ');
      },
      clearMessage() {
        this.message = '';
        document.getElementById('comments-input').innerText = '';
      },
      add() {
        if (this.message) {
          this.$emit('addComments', this.message);
          this.clearMessage();
        } else {
          this.$error({message: this.$getErr('NO_COMMENT_ENTERED')});
        }
      },
      getHighlightedMessage(message) {
        const html = this.$sanitize(message);
        return html;
      },
      preventDefault(event) {
        event.stopPropagation();
      },
    },
  };
</script>
<style lang="scss">
  html {
    position: relative;
  }
</style>
